
import {
  IRPCRequest,
  IRPCResult,
  ListeningTicket,
} from "./types";

import {
  IEnhancementRecord
} from '../enhancements';

import{
  RequestIdentifier
  
} from '../request';

import {
  RequestUpdatedEventName
} from '../rpc/bar'

import {
  IRPCPublishment
} from "./publishment";

export interface IRPCResponseWrapper {
  send(result: IRPCResult): void;
}

export interface IInjectTransportResponder {
 (request: IRPCRequest, response: IRPCResponseWrapper): void
}

export interface IInjectTransport {
  startListening(): void;
  stopListening(ticket: string): void;
  publish(message: IRPCPublishment): void;
  addListener(responder: IInjectTransportResponder): ListeningTicket;
  removeListener(ticket: ListeningTicket): void;
}

export interface ISimpleFetchPublisher {
  onRequestStarted({
    id, 
    request, 
    initiatedTimestamp, 
    enhancement 
  }: {
    id: RequestIdentifier, 
    request: Request, 
    requestBody?: string, 
    initiatedTimestamp: number,
    enhancement?: IEnhancementRecord 
  }): void;
  onRequestUpdated(parameters: { [key: string]: any }, eventName: RequestUpdatedEventName): void;
}
